<div class="lmo-loader-closed-schedule">
  <h1>Non-Operational Hours</h1>
  <mat-form-field>
    <mat-label>Select Loader</mat-label>
    <mat-select [value]="selectedId$ | async">
      <mat-option *ngFor="let loader of inUseLoaders$ | async" [value]="loader.id" [routerLink]="[loader.id]">
        {{ loader.site.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <div class="router-outlet">
    <router-outlet></router-outlet>
  </div>
</div>
